export enum TEMP_CONTROLS {
  'Fixed' = 'Fixed',
  'Range' = 'Range',
}

export enum EQUIPMENTS {
  'dry_van' = 'Dry Van',
  'reefer' = 'Reefer',
  'open_deck' = 'Flatbed',
}

export enum ANALYTICS_COVERAGE_TYPES {
  'auction' = 'Assigned by Auction',
  'routing_guide' = 'Assigned by Routing Guide',
  'direct_assignment' = 'Assigned by Direct Tender',
}

export enum APPOINTMENTS {
  'scheduled' = 'I have an appointment',
  'fcfs' = 'First come, first served',
  'carrier_must_schedule' = 'Carrier to schedule',
}

export enum COVERAGE {
  'routing_guide' = 'Primary Carriers',
  'auction' = 'Capacity Finder',
}

export interface IReeferDetails {
  fixedTemp?: string
  maxTemp?: string
  minTemp?: string
  precoolTemp?: string
  tempControlType?: keyof typeof TEMP_CONTROLS
}

export interface IFacilityLocation {
  address: string
  dockBldgLot?: string
  city: string
  stateCode: string
  zipcode: string
  countryCode?: string
  timezone?: string
}

export interface ILocation {
  city: string
  state: string
}

export interface IFacilityContact {
  name: string
  phone?: string
  phoneExt?: string
  email: string
}
export interface IShipmentStopFacility {
  name: string
  shipperFacilityUuid: string
  location: IFacilityLocation
  contact: IFacilityContact
  newFacility?: boolean
}

export interface IShipmentStopAppointment {
  appointmentType: keyof typeof APPOINTMENTS
  appointmentDate: string
  appointmentTime: string
  instructions?: string
}

export interface IShipmentStopDetails {
  facility: IShipmentStopFacility
  appointment: IShipmentStopAppointment
  referenceNumber: string
}

export interface IOverviewInfo {
  pickupCity?: string
  pickupStateCode?: string
  deliveryCity?: string
  deliveryStateCode?: string
  firstPickupDate?: string
  lastDeliveryDate?: string
  miles?: number
  numberOfStops?: number
}

export interface ICoverageType {
  coverageType?: keyof typeof COVERAGE
  carrierId?: string
}
